<template>
  <v-card>
    <v-card-title>
      {{ fund.precheck ? $t("auditor.precheck.success.title") : $t("auditor.minimal.success.title") }}
    </v-card-title>

    <v-card-text>
      {{ fund.precheck ? $t("auditor.precheck.success.text") : $t("auditor.minimal.success.text") }}
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="primary"
        :to="{
          name: 'auditAuditPeriod',
          params: { id: fund.auditPeriod.id },
        }"
      >
        {{ fund.precheck ? $t("auditor.precheck.success.cta") : $t("auditor.minimal.success.cta") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    fund: {
      type: Object,
      required: true,
    },
  },
};
</script>
